import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { Paper } from "@mui/material";
import React, { useState } from "react";
import CandidatePersonalDetailsForm from "./CandidatePersonalDetailsForm";
import SocialNetwork from "./SocialNetwork";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import ProfileSummary from "./ProfileSummary";
import Skills from "./Skills";
import ContactInformation from "./ContactInformation";
import RelatedTitles from "./RelatedTitles";
import ProfileStrengthChart from "./ProfileStrengthChart";
import { useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { myCandidatesSelector } from "../redux/selector";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const ProfileView = ({ candidateRefreshHandlerDetailView }) => {
  const { candidateDetails } = useSelector(myCandidatesSelector);
  const [formData, setFormData] = useState([
    {}, // form1Data
    {}, // form2Data
    {}, // form3Data
    {}, // form4Data
    {}, // form5Data
    {}, // form6Data
  ]);

  const formDataHnadler = (data, form) => {
    // Determine which form section to update based on the 'form' parameter
    const updatedFormData = formData.map((formSection, index) => {
      if (index === parseInt(form.charAt(1)) - 1) {
        // Convert 'f1', 'f2', ... to index
        return data; // Update the data for the corresponding form section
      }
      return formSection; // Keep other form sections unchanged
    });

    setFormData(updatedFormData);
  };

  const candidatesRefreshHandler = async () => {
    await candidateRefreshHandlerDetailView();
  };
  return (
    <Paper
      elevation={1}
      sx={{
        height: "100vh",
        borderRadius: "6px",
        padding: "10px",
        bgcolor: "rgb(242, 244, 250)",
        overflow: "scroll",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          variant="h5"
          sx={{
            color: "rgb(5, 38, 78)",
            mb: "10px",
            textTransform: "capitalize",
          }}
        >
          Candidate Profile
        </Typography>
        <Box />
        <Typography
          variant="body1"
          sx={{
            color: "rgb(5, 38, 78)",
            mb: "10px",
            textTransform: "capitalize",
          }}
        >
          userId : {candidateDetails.email}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CandidatePersonalDetailsForm
                formDataHnadler={formDataHnadler}
                candidatesRefreshHandler={candidatesRefreshHandler}
              />
            </Grid>
            <Grid item xs={12}>
              <ProfileSummary formDataHnadler={formDataHnadler} />
            </Grid>
            <Grid item xs={12}>
              <ContactInformation formDataHnadler={formDataHnadler} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ProfileStrengthChart formData={formData} />
            </Grid>
            <Grid item xs={12}>
              <Skills formDataHnadler={formDataHnadler} />
            </Grid>
            <Grid item xs={12}>
              <RelatedTitles formDataHnadler={formDataHnadler} />
            </Grid>
            <Grid item xs={12}>
              <SocialNetwork formDataHnadler={formDataHnadler} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProfileView;
